var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.75H12C11.59 20.75 11.25 20.41 11.25 20C11.25 19.59 11.59 19.25 12 19.25H17C19.86 19.25 21.25 17.86 21.25 15V9C21.25 6.14 19.86 4.75 17 4.75H7C4.14 4.75 2.75 6.14 2.75 9V11C2.75 11.41 2.41 11.75 2 11.75C1.59 11.75 1.25 11.41 1.25 11V9C1.25 5.35 3.35 3.25 7 3.25H17C20.65 3.25 22.75 5.35 22.75 9V15C22.75 18.65 20.65 20.75 17 20.75Z",
    fill: "#6A6077"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.25C10.21 15.25 8.75 13.79 8.75 12C8.75 10.21 10.21 8.75 12 8.75C13.79 8.75 15.25 10.21 15.25 12C15.25 13.79 13.79 15.25 12 15.25ZM12 10.25C11.04 10.25 10.25 11.04 10.25 12C10.25 12.96 11.04 13.75 12 13.75C12.96 13.75 13.75 12.96 13.75 12C13.75 11.04 12.96 10.25 12 10.25Z",
    fill: "#6A6077"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15.25C18.09 15.25 17.75 14.91 17.75 14.5V9.5C17.75 9.09 18.09 8.75 18.5 8.75C18.91 8.75 19.25 9.09 19.25 9.5V14.5C19.25 14.91 18.91 15.25 18.5 15.25Z",
    fill: "#6A6077"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 18.69C8.09 18.69 7.75 18.35 7.75 17.94V16.66C7.75 16.44 7.57003 16.25 7.34003 16.25H2C1.59 16.25 1.25 15.91 1.25 15.5C1.25 15.09 1.59 14.75 2 14.75H7.34003C8.39003 14.75 9.25 15.61 9.25 16.66V17.94C9.25 18.35 8.91 18.69 8.5 18.69Z",
    fill: "#6A6077"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21994 17.4699C3.02994 17.4699 2.83997 17.4 2.68997 17.25L1.46994 16.03C1.17994 15.74 1.17994 15.2599 1.46994 14.9699L2.68997 13.75C2.97997 13.46 3.45997 13.46 3.74997 13.75C4.03997 14.04 4.03997 14.52 3.74997 14.81L3.05997 15.5L3.74997 16.19C4.03997 16.48 4.03997 16.96 3.74997 17.25C3.59997 17.4 3.40994 17.4699 3.21994 17.4699Z",
    fill: "#6A6077"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 21.5301H3.15997C2.10997 21.5301 1.25 20.6701 1.25 19.6201V18.3401C1.25 17.9301 1.59 17.5901 2 17.5901C2.41 17.5901 2.75 17.9301 2.75 18.3401V19.6201C2.75 19.8401 2.92997 20.0301 3.15997 20.0301H8.5C8.91 20.0301 9.25 20.3701 9.25 20.7801C9.25 21.1901 8.91 21.5301 8.5 21.5301Z",
    fill: "#6A6077"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.27976 22.75C7.08976 22.75 6.89973 22.68 6.74973 22.53C6.45973 22.24 6.45973 21.7599 6.74973 21.4699L7.43973 20.78L6.74973 20.09C6.45973 19.8 6.45973 19.32 6.74973 19.03C7.03973 18.74 7.51972 18.74 7.80972 19.03L9.02976 20.25C9.31976 20.54 9.31976 21.02 9.02976 21.31L7.80972 22.53C7.66972 22.68 7.46976 22.75 7.27976 22.75Z",
    fill: "#6A6077"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyChange);
export default __webpack_public_path__ + "static/media/money-change.51d243b37673c1c9fa359dcedb459d16.svg";
export { ForwardRef as ReactComponent };